import type { Component } from 'vue';
import Chat from './Chat.vue';

export default new Map<string, Component>([
  ['Chat', Chat],
]);



